import { useTranslation } from "react-i18next";
import { useRemoteMutation } from "../../useRemote/useRemoteMutation";
import { RemoteApiError } from "../../useRemote/types";

export function useRemoteUpdateCateringMenu() {
  const { t } = useTranslation();

  return useRemoteMutation<void, RemoteApiError, FormData>({
    key: ["update-catering-menu"],
    url: `/booking-services/catering-services`,
    method: "patch",
    snackbarTextOnSuccess: t("Successfully updated a catering"),
    snackbarTextOnFail: t(`There was a server error`)
  });
}
